import { useDebugContext } from '@/context/DebugContext';
export const useDebug = useDebugContext;
